<template>
  <div class="position-relative stepr p-0">
    <span class="horizontal-line"></span>
    <ul class="stepper stepper-horizontal">
      <li class="horizontal-step step" :class="stepOneStatus">
        <a class="ripple-parent w-100">
          <span class="circle">
            <span>1</span>
          </span>
          <span class="label">
            About employee
          </span>
        </a>
      </li>

      <li class="horizontal-step step" :class="stepTwoStatus">
        <a class="ripple-parent w-100">
          <span class="circle">
            <span>2</span>
          </span>
          <span class="label">
            Reduction details
          </span>
        </a>
      </li>

      <li class="horizontal-step step" :class="stepThreeStatus">
        <a class="ripple-parent w-100">
          <span class="circle">
            <span>3</span>
          </span>
          <span class="label">
            Updated salary
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "WizardStep",
  props: {
    step: Number
  },
  computed: {
    stepOneStatus: function() {
      return this.step > 1 ? "completed" : "active";
    },
    stepTwoStatus: function() {
      return this.step > 2 ? "completed" : this.step > 1 ? "active" : "";
    },
    stepThreeStatus: function() {
      return this.step > 3 ? "completed" : this.step > 2 ? "active" : "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* h3 {
  margin: 0px 0 0;
} */
</style>
